<template>
    <span v-if="readonly" class="tag">
        {{ translate("discipline_packages.bracket_repechage_by_finalists_default") }}
    </span>
    <div v-else class="is-flex is-align-items-center repechage-settings" style="gap: 0.4rem">
        <div class="select is-small">
            <select v-model="numberOfThirdPlacesValue">
                <option value="2">
                    {{ translate("discipline_packages.bracket_repechage_by_finalists_two_third_places") }}
                </option>
                <option value="1">
                    {{ translate("discipline_packages.bracket_repechage_by_finalists_one_third_place") }}
                </option>
            </select>
        </div>
        <div class="select is-small">
            <select v-model="pullDepthValue">
                <option value="all">
                    {{ translate("discipline_packages.bracket_repechage_by_finalists_pull_depth_all") }}
                </option>
                <option v-for="depth in pullDepthOptions" :key="depth" :value="String(depth)">
                    {{ pullDepthLabel(depth) }}
                </option>
            </select>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import { translate } from "../../Common/translations";
    import { RepechageByFinalistsSettings } from "../../Brackets/configurationTemplates";

    const DEFAULT_TWO_THIRD_PLACES = 2;

    withDefaults(
        defineProps<{
            readonly?: boolean;
        }>(),
        {
            readonly: false,
        },
    );

    const settings = defineModel<RepechageByFinalistsSettings | undefined>();

    const pullDepthOptions = [1, 2, 3, 4];

    const numberOfThirdPlacesValue = computed({
        get: () => String(settings.value?.numberOfThirdPlaces ?? DEFAULT_TWO_THIRD_PLACES),
        set: (value: string) => {
            settings.value = {
                ...(settings.value ?? {}),
                numberOfThirdPlaces: Number(value),
            };
        },
    });

    const pullDepthValue = computed({
        get: () => {
            const pullDepth = settings.value?.pullDepth ?? null;
            return pullDepth === null ? "all" : String(pullDepth);
        },
        set: (value: string) => {
            settings.value = {
                ...(settings.value ?? {}),
                pullDepth: value === "all" ? null : Number(value),
            };
        },
    });

    function pullDepthLabel(depth: number): string | null {
        if (depth === 1) {
            return translate("discipline_packages.bracket_repechage_by_finalists_pull_depth_one");
        }

        return translate("discipline_packages.bracket_repechage_by_finalists_pull_depth_rounds", false, [depth]);
    }
</script>

<style scoped>
    .repechage-settings {
        flex-wrap: wrap;
    }
</style>
